import { MasterButton, Modal } from "App/Component/ui"
import { Grid } from "@material-ui/core"
import React, { useContext, useState } from "react"
import {
  defaultToastError,
  defaultToastSuccess,
  toUTCFormat,
  isNull,
  today,
  convertToValidPrice,
} from "App/utils/helpers"
import { DISABLED_BUTTON_SUBMIT, instance2, instance3 } from "App/constants"
import { FormContext } from "../../../../context/FormContext"
import {
  validationFormPenjualan,
  getTotal,
  urlCreate,
  urlUpdate,
  validInputArray,
  urlCreateExternal,
  STATUS_TRANSAKI_PENJUALAN_TUTUP,
  STATUS_TRANSAKI_PENJUALAN_KUNCI,
} from "../../.."
import {
  STATUS_TRANSAKI_PENJUALAN_OPEN_DRAFT,
  urlClosePenjualan,
  urlUpdateExternal,
} from "../../../helpers"

export const SHOW_BUKA_TRANSAKSI = {
  label: "BUKA TRANSAKSI",
  color: "green",
  state: false,
  disabled: false,
}

export const SHOW_BUKA_KUNCI_TRANSAKSI = {
  label: "BUKA KUNCI TRANSAKSI",
  color: "green",
  state: false,
  disabled: false,
}

export const SHOW_TUTUP_TRANSAKSI = {
  label: "TUTUP TRANSAKSI",
  color: "lightgreen",
  state: false,
  disabled: false,
}

const SHOW_UPDATE_TRANSAKSI = {
  label: "UPDATE TRANSAKSI",
  color: "green",
  state: false,
  disabled: false,
}

const SHOW_KUNCI_TRANSAKSI = {
  label: "KUNCI TRANSAKSI",
  color: "green",
  state: false,
  disabled: false,
}

const SHOW_KUNCI_TUTUP_KUNJUNGAN = {
  label: "KUNCI TRANSAKSI & SELESAIKAN KUNJUNGAN",
  color: "green",
  state: false,
  disabled: false,
}

const SHOW_TUTUP_KUNJUNGAN = {
  label: "TUTUP TRANSAKSI & SELESAIKAN KUNJUNGAN",
  color: "green",
  state: true,
  disabled: false,
}

const ModalSimpan = ({
  setShowModal,
  perhitunganPenjualan,
  setDataNotif,
  setShowModalNotifikasi,
}) => {
  const { formData, setFormData } = useContext(FormContext)

  const createPenjualan = async () => {
    const totalBarang = getTotal(formData.barang, "barang")
    const totalRikjang = getTotal(formData.rikjang, "rikjang")
    const totalJasa = getTotal(formData.jasa, "jasa")
    const totalFasilitas = getTotal(formData.fasilitas, "fasilitas")
    const totalPaket = getTotal(formData.paket, "paket")

    const jumlah =
      totalBarang + totalRikjang + totalJasa + totalFasilitas + totalPaket
    const potongan = isNull(formData.potongan) ? 0 : formData.potongan
    const subTotal = jumlah - potongan

    const taxPercent = isNull(formData.tax_percent) ? 0 : formData.tax_percent
    const taxNumber = isNull(formData.tax_percent)
      ? 0
      : (formData.tax_percent / 100) * subTotal

    const total = subTotal + taxNumber
    const pembayaran = isNull(formData.pembayaran) ? 0 : formData.pembayaran
    const sisa = total - pembayaran
    const discount = isNull(formData.potongan) ? 0 : formData.potongan / total

    const defaultData = {
      date: toUTCFormat(formData.date),
      /**
       * jangan di-hardcode. jika kosong, key ini dibuang oleh loop isNull di bawah
       * sehingga backend yang menentukan sendiri saat register
       */
      id_type_of_care: formData.id_type_of_care,
      id_jenis_layanan: formData.jenis_layanan_id,
      id_kelas: formData.kelas_id,
      harga_total_barang: convertToValidPrice(totalBarang),
      harga_total_jasa: convertToValidPrice(totalJasa),
      harga_total_fasilitas: convertToValidPrice(totalFasilitas),
      harga_total_rikjang: convertToValidPrice(totalRikjang),
      harga_total_paket: convertToValidPrice(totalPaket),
      discount: isNaN(discount) ? 0 : discount.toFixed(2),
      jumlah_set_discount: convertToValidPrice(potongan),
      tax: taxPercent,
      jumlah_tax: isNaN(taxNumber) ? 0 : taxNumber.toFixed(2),
      total_Penjualan: convertToValidPrice(jumlah),
      is_lock: false,
      is_close: false,
      kas_id: formData.kas_bank_id,
      msTipePembayaranId: formData.tipe_pembayaran_id,
      petugas: formData.petugas,
      id_dokter: formData.dokter_id,
      gudang_id: formData.gudang_id,
      insurance_id: formData.asuransi_id,
      insurance_no: formData.noasuransi,

      id_rm: formData.rm_id,
      namaGudang: formData.gudang_name,
      nama_rm: formData.nama,

      fasilitas: validInputArray(formData.fasilitas),
      jasa: validInputArray(formData.jasa),
      rikjang: validInputArray(formData.rikjang),
      paket: validInputArray(formData.paket),
      barang: validInputArray(formData.barang),

      status_transaksi: STATUS_TRANSAKI_PENJUALAN_OPEN_DRAFT,
    }

    for (const key in defaultData) {
      if (isNull(defaultData[key]) || defaultData[key] === "-") {
        delete defaultData[key]
      }
    }

    if (isNull(formData.penjualan_id)) {
      if (isNull(formData.kunjungan_id)) {
        const api = await instance3.post(urlCreateExternal, {
          ...defaultData,
          nama: formData.nama,
          keterangan: formData.keterangan,
          isExternal: 1,
          intext: false,
          bayar_jual: 0,
          sisa: sisa,
          sumber_penj: 1, //SIM RS,
          is_jurnal: true,
        })
        return api
      } else {
        const api = await instance3.post(urlCreate, {
          ...defaultData,
          isExternal: 0,
          bayar_jual: 0,
          id_kunjungan: formData.kunjungan_id,
          sisa: sisa,
          sumber_penj: 1, //SIM RS,
          is_jurnal: true,
        })

        return api
      }
    } else {
      /**
       * update cek jika kunjungan id kosong, maka penjualan external
       */

      if (isNull(formData.kunjungan_id)) {
        const api = await instance3.post(urlUpdateExternal, {
          ...defaultData,
          id: formData.penjualan_id,
          nama: formData.nama,
          keterangan: formData.keterangan,
          isExternal: 1,
          intext: false,
          sisa: sisa > 0 ? sisa.toFixed(2) : 0,
          is_lock: false,
          is_close: false,
          is_jurnal: true,
        })
        return api
      } else {
        const api = await instance3.post(urlUpdate, {
          ...defaultData,
          id: formData.penjualan_id,
          isExternal: 0,
          sisa: sisa > 0 ? sisa.toFixed(2) : 0,
          id_kunjungan: formData.kunjungan_id,
          is_lock: false,
          is_close: false,
          is_jurnal: true,
        })
        return api
      }
    }
  }

  return (
    <Modal title={"Simpan"} show={setShowModal} width="20%">
      <Grid container direction="row" alignItems="center">
        <ButtonActionBukaTransaksi
          formData={formData}
          setFormData={setFormData}
          createPenjualan={createPenjualan}
          setShowModal={setShowModal}
          setDataNotif={setDataNotif}
          setShowModalNotifikasi={setShowModalNotifikasi}
        />

        <ButtonActionBukaKunciTransaksi
          formData={formData}
          setFormData={setFormData}
          createPenjualan={createPenjualan}
          setShowModal={setShowModal}
        />

        <ButtonActionUpdateTransaksi
          formData={formData}
          setFormData={setFormData}
          createPenjualan={createPenjualan}
          setShowModal={setShowModal}
        />

        <ButtonActionKunciTransaksi
          formData={formData}
          setFormData={setFormData}
          createPenjualan={createPenjualan}
          setShowModal={setShowModal}
        />

        <ButtonActionTutupTransaksi
          formData={formData}
          setFormData={setFormData}
          perhitunganPenjualan={perhitunganPenjualan}
          setShowModal={setShowModal}
        />

        {formData.status_transaksi === STATUS_TRANSAKI_PENJUALAN_TUTUP && (
          <p> Penjualan sudah tertutup</p>
        )}
      </Grid>
    </Modal>
  )
}

const ButtonActionBukaKunciTransaksi = ({
  formData,
  setFormData,
  setShowModal,
}) => {
  const [disabledBukaTransaksi, setDisabledBukaTransaksi] = useState(
    SHOW_BUKA_KUNCI_TRANSAKSI,
  )

  const handleClickBukaKunciTransaksi = async (e) => {
    e.preventDefault()
    setDisabledBukaTransaksi(DISABLED_BUTTON_SUBMIT)
    const valid = validationFormPenjualan(formData)
    if (valid?.state) {
      try {
        // const res = await createPenjualan();

        const res = await instance3.post(urlClosePenjualan, {
          id: formData.penjualan_id,
          is_lock: false,
          tgl_lock: today(),
          status_transaksi: STATUS_TRANSAKI_PENJUALAN_OPEN_DRAFT,
        })

        if (res.data.status === 200) {
          setDisabledBukaTransaksi(SHOW_BUKA_KUNCI_TRANSAKSI)
          defaultToastSuccess(res.data.message)
          setShowModal(false)
          setFormData({
            ...formData,
            is_lock: false,
            status_transaksi: STATUS_TRANSAKI_PENJUALAN_OPEN_DRAFT,
            is_jurnal: true,
          })
        } else {
          setDisabledBukaTransaksi(SHOW_BUKA_KUNCI_TRANSAKSI)
          defaultToastError(
            `${res.data.message} ${res.data?.data[0]?.namaBarang}`,
          )
        }
      } catch (error) {
        setDisabledBukaTransaksi(SHOW_BUKA_KUNCI_TRANSAKSI)
        defaultToastError(error?.response?.data?.message)
      }
    } else {
      setDisabledBukaTransaksi(SHOW_BUKA_KUNCI_TRANSAKSI)
      defaultToastError(valid?.message)
    }
  }

  if (
    !isNull(formData.penjualan_id) &&
    formData.status_transaksi === STATUS_TRANSAKI_PENJUALAN_KUNCI
  ) {
    return (
      <MasterButton
        className={"mt-1 w-full text-center"}
        type={"button"}
        color={disabledBukaTransaksi.color}
        name={disabledBukaTransaksi.label}
        disabled={disabledBukaTransaksi.state}
        size="lg"
        onClick={(e) =>
          disabledBukaTransaksi.disabled
            ? null
            : handleClickBukaKunciTransaksi(e)
        }
      />
    )
  } else {
    return <></>
  }
}

const ButtonActionBukaTransaksi = ({
  formData,
  setFormData,
  createPenjualan,
  setShowModal,
  setDataNotif,
  setShowModalNotifikasi,
}) => {
  const [disabledBukaTransaksi, setDisabledBukaTransaksi] =
    useState(SHOW_BUKA_TRANSAKSI)

  const handleClickBukaTransaksi = async (e) => {
    e.preventDefault()
    setDisabledBukaTransaksi(DISABLED_BUTTON_SUBMIT)
    const valid = validationFormPenjualan(formData)
    if (valid?.state) {
      try {
        const res = await createPenjualan()
        if (res.data.status === 200) {
          setDisabledBukaTransaksi(SHOW_BUKA_TRANSAKSI)
          defaultToastSuccess(res.data.message)
          setShowModal(false)

          if (
            !isNull(res?.data?.data_notif?.length) &&
            res?.data?.data_notif.length > 0
          ) {
            setDataNotif(res?.data?.data_notif)
            setShowModalNotifikasi(true)
          } else {
            setShowModalNotifikasi(false)
            setDataNotif([])
          }

          if (isNull(formData.penjualan_id)) {
            if (isNull(formData.kunjungan_id)) {
              setFormData({
                ...formData,
                penjualan_id: res.data.penjualanId,
                idExt: res.data.idExt,
                is_jurnal: true,
              })
            } else {
              setFormData({
                ...formData,
                penjualan_id: res.data.id,
                is_jurnal: true,
              })
            }
          } else {
            setFormData({
              ...formData,
              is_lock: false,
              is_jurnal: true,
            })
          }
        } else {
          setDisabledBukaTransaksi(SHOW_BUKA_TRANSAKSI)
          defaultToastError(
            `${res.data.message} ${res.data?.data[0]?.namaBarang}`,
          )
        }
      } catch (error) {
        setDisabledBukaTransaksi(SHOW_BUKA_TRANSAKSI)
        const messageError = !isNull(error?.response?.data?.data?.message)
          ? error?.response?.data?.data?.message
          : error?.response?.data?.message
        defaultToastError(messageError)
      }
    } else {
      setDisabledBukaTransaksi(SHOW_BUKA_TRANSAKSI)
      defaultToastError(valid?.message)
    }
  }

  if (
    isNull(formData.penjualan_id) &&
    !formData.is_lock &&
    !formData.is_close
  ) {
    return (
      <MasterButton
        className={"mt-1 w-full text-center"}
        id="btn-buka-transaksi"
        type={"button"}
        color={disabledBukaTransaksi.color}
        name={disabledBukaTransaksi.label}
        disabled={disabledBukaTransaksi.state}
        size="lg"
        onClick={(e) =>
          disabledBukaTransaksi.disabled ? null : handleClickBukaTransaksi(e)
        }
      />
    )
  } else {
    return <></>
  }
}

const ButtonActionUpdateTransaksi = ({
  formData,
  setFormData,
  createPenjualan,
  setShowModal,
}) => {
  const [disabledUpdateTransaksi, setDisabledUpdateTransaksi] = useState(
    SHOW_UPDATE_TRANSAKSI,
  )

  const handleClickUpdateTransaksi = async (e) => {
    e.preventDefault()
    setDisabledUpdateTransaksi(DISABLED_BUTTON_SUBMIT)
    const valid = validationFormPenjualan(formData)
    if (valid?.state) {
      try {
        const res = await createPenjualan()
        if (res.data.status === 200) {
          setDisabledUpdateTransaksi(SHOW_UPDATE_TRANSAKSI)
          defaultToastSuccess(res.data.message)
          setShowModal(false)

          if (isNull(formData.penjualan_id)) {
            if (isNull(formData.kunjungan_id)) {
              setFormData({
                ...formData,
                penjualan_id: res.data.penjualanId,
                idExt: res.data.idExt,
                status_transaksi: STATUS_TRANSAKI_PENJUALAN_OPEN_DRAFT,
                is_jurnal: true,
              })
            } else {
              setFormData({
                ...formData,
                penjualan_id: res.data.id,
                status_transaksi: STATUS_TRANSAKI_PENJUALAN_OPEN_DRAFT,
                is_jurnal: true,
              })
            }
          } else {
            setFormData({
              ...formData,
              is_lock: false,
              status_transaksi: STATUS_TRANSAKI_PENJUALAN_OPEN_DRAFT,
              is_jurnal: true,
            })
          }
        } else {
          setDisabledUpdateTransaksi(SHOW_UPDATE_TRANSAKSI)
          defaultToastError(
            `${res.data.message} ${res.data?.data[0]?.namaBarang}`,
          )
        }
      } catch (error) {
        setDisabledUpdateTransaksi(SHOW_UPDATE_TRANSAKSI)
        defaultToastError(error?.response?.data?.message)
      }
    } else {
      setDisabledUpdateTransaksi(SHOW_UPDATE_TRANSAKSI)
      defaultToastError(valid?.message)
    }
  }

  if (
    !isNull(formData.penjualan_id) &&
    formData.status_transaksi === STATUS_TRANSAKI_PENJUALAN_OPEN_DRAFT
  ) {
    return (
      <MasterButton
        className={"mt-1 w-full text-center"}
        type={"button"}
        color={disabledUpdateTransaksi.color}
        name={disabledUpdateTransaksi.label}
        disabled={disabledUpdateTransaksi.state}
        size="lg"
        onClick={(e) =>
          disabledUpdateTransaksi.disabled
            ? null
            : handleClickUpdateTransaksi(e)
        }
      />
    )
  } else {
    return <></>
  }
}

const ButtonActionKunciTransaksi = ({
  formData,
  setFormData,
  setShowModal,
}) => {
  const [disabledKunciTransaksi, setDisabledKunciTransaksi] =
    useState(SHOW_KUNCI_TRANSAKSI)
  const [disabledKunciTutupKunjungan, setDisabledKunciTutupKunjungan] =
    useState(SHOW_KUNCI_TUTUP_KUNJUNGAN)
  const handleClickKunciTransaksi = async (e) => {
    e.preventDefault()
    setDisabledKunciTransaksi(DISABLED_BUTTON_SUBMIT)
    const valid = validationFormPenjualan(formData)
    if (valid.state) {
      try {
        const res = await instance3.post(urlClosePenjualan, {
          id: formData.penjualan_id,
          is_lock: true,
          tgl_lock: today(),
          status_transaksi: STATUS_TRANSAKI_PENJUALAN_KUNCI,
        })
        if (res.data.status === 200) {
          setDisabledKunciTransaksi(SHOW_KUNCI_TRANSAKSI)
          defaultToastSuccess(res.data.message)
          setShowModal(false)

          setFormData({
            ...formData,
            is_lock: true,
            tgl_lock: today(),
            status_transaksi: STATUS_TRANSAKI_PENJUALAN_KUNCI,
            is_jurnal: true,
          })
        } else {
          setDisabledKunciTransaksi(SHOW_KUNCI_TRANSAKSI)
          defaultToastError(`${res.data.message}}`)
        }
      } catch (error) {
        setDisabledKunciTransaksi(SHOW_KUNCI_TRANSAKSI)
        defaultToastError(error?.response?.data?.message)
      }
    } else {
      setDisabledKunciTransaksi(SHOW_KUNCI_TRANSAKSI)
      defaultToastError(valid?.message)
    }
  }

  const handleClickLockTutupKunjungan = async (e) => {
    e.preventDefault()
    setDisabledKunciTutupKunjungan(DISABLED_BUTTON_SUBMIT)
    const valid = validationFormPenjualan(formData)
    if (valid.state) {
      try {
        const res = await instance3.post(urlClosePenjualan, {
          id: formData.penjualan_id,
          is_lock: true,
          tgl_lock: today(),
          status_transaksi: STATUS_TRANSAKI_PENJUALAN_KUNCI,
        })
        if (res.data.status === 200) {
          setDisabledKunciTutupKunjungan(SHOW_KUNCI_TUTUP_KUNJUNGAN)
          defaultToastSuccess(res.data.message)
          setShowModal(false)

          if (!isNull(formData.kunjungan_id)) {
            await instance2.post(
              "registration/registration/tutupregistrasi",
              {
                tanggal_selesai: today(true),
              },
              {
                headers: {
                  idregistration: formData.kunjungan_id,
                },
              },
            )
          }
          setFormData({
            ...formData,
            is_lock: true,
            tgl_lock: today(),
            status_transaksi: STATUS_TRANSAKI_PENJUALAN_KUNCI,
            is_jurnal: true,
          })
        } else {
          setDisabledKunciTutupKunjungan(SHOW_KUNCI_TUTUP_KUNJUNGAN)
          defaultToastError(`${res.data.message}}`)
        }
      } catch (error) {
        setDisabledKunciTutupKunjungan(SHOW_KUNCI_TUTUP_KUNJUNGAN)
        defaultToastError(error?.response?.data?.message)
      }
    } else {
      setDisabledKunciTutupKunjungan(SHOW_KUNCI_TUTUP_KUNJUNGAN)
      defaultToastError(valid?.message)
    }
  }

  if (
    !isNull(formData.penjualan_id) &&
    formData.status_transaksi === STATUS_TRANSAKI_PENJUALAN_OPEN_DRAFT
  ) {
    return (
      <>
        <MasterButton
          className={"mt-1 w-full text-center"}
          type={"button"}
          outline={true}
          onClick={(e) =>
            disabledKunciTransaksi.disable ? null : handleClickKunciTransaksi(e)
          }
          color={disabledKunciTransaksi.color}
          name={disabledKunciTransaksi.label}
          disabled={disabledKunciTransaksi.state}
          size="lg"
        />

        {!isNull(formData.kunjungan_id) && (
          <MasterButton
            className={"mt-1 w-full text-center"}
            type={"button"}
            outline={true}
            onClick={(e) =>
              disabledKunciTutupKunjungan.disabled
                ? null
                : handleClickLockTutupKunjungan(e)
            }
            color={disabledKunciTutupKunjungan.color}
            name={disabledKunciTutupKunjungan.label}
            disabled={disabledKunciTutupKunjungan.state}
            size="lg"
          />
        )}
      </>
    )
  } else {
    return <></>
  }
}

const ButtonActionTutupTransaksi = ({
  formData,
  setFormData,
  setShowModal,
  perhitunganPenjualan,
}) => {
  const [disabledTutupTransaksi, setDisabledTutupTransaksi] =
    useState(SHOW_TUTUP_TRANSAKSI)

  const [disabledTutupKunjungan, setDisabledTutupKunjungan] =
    useState(SHOW_TUTUP_KUNJUNGAN)

  const handleClickTutupTransaksi = async (e) => {
    e.preventDefault()
    setDisabledTutupTransaksi(DISABLED_BUTTON_SUBMIT)
    const valid = validationFormPenjualan(formData)
    if (valid?.state) {
      try {
        const res = await instance3.post(urlClosePenjualan, {
          id: formData.penjualan_id,
          is_close: true,
          tgl_close: today(),
          status_transaksi: STATUS_TRANSAKI_PENJUALAN_TUTUP,
        })
        if (res.data.status === 200) {
          setDisabledTutupTransaksi(SHOW_TUTUP_TRANSAKSI)
          defaultToastSuccess(res.data.message)
          setShowModal(false)

          setFormData({
            ...formData,
            is_close: true,
            tgl_close: today(),
            status_transaksi: STATUS_TRANSAKI_PENJUALAN_TUTUP,
            is_jurnal: true,
          })
        } else {
          setDisabledTutupTransaksi(SHOW_TUTUP_TRANSAKSI)
          defaultToastError(`${res.data.message}}`)
        }
      } catch (error) {
        setDisabledTutupTransaksi(SHOW_TUTUP_TRANSAKSI)
        defaultToastError(error?.response?.data?.message)
      }
    } else {
      setDisabledTutupTransaksi(SHOW_TUTUP_TRANSAKSI)
      defaultToastError(valid?.message)
    }
  }

  const handleClickTutupKunjungan = async (e) => {
    e.preventDefault()
    setDisabledTutupKunjungan(DISABLED_BUTTON_SUBMIT)
    const valid = validationFormPenjualan(formData)
    if (valid.state) {
      try {
        const res = await instance3.post(urlUpdate, {
          id: formData.penjualan_id,
          is_close: true,
          tgl_close: today(),
          status_transaksi: STATUS_TRANSAKI_PENJUALAN_TUTUP,
        })
        if (res.data.status === 200) {
          setDisabledTutupKunjungan(SHOW_TUTUP_KUNJUNGAN)
          defaultToastSuccess(res.data.message)
          setShowModal(false)

          if (!isNull(formData.kunjungan_id)) {
            await instance2.post(
              "registration/registration/tutupregistrasi",
              {
                tanggal_selesai: today(true),
              },
              {
                headers: {
                  idregistration: formData.kunjungan_id,
                },
              },
            )
          }
          setFormData({
            ...formData,
            is_close: true,
            tgl_close: today(),
            is_jurnal: true,
          })
        } else {
          setDisabledTutupKunjungan(SHOW_TUTUP_KUNJUNGAN)
          defaultToastError(`${res.data.message}}`)
        }
      } catch (error) {
        setDisabledTutupKunjungan(SHOW_TUTUP_KUNJUNGAN)
        defaultToastError(error?.response?.data?.message)
      }
    } else {
      setDisabledTutupKunjungan(SHOW_TUTUP_KUNJUNGAN)
      defaultToastError(valid?.message)
    }
  }

  if (
    !isNull(formData.penjualan_id) &&
    formData.status_transaksi === STATUS_TRANSAKI_PENJUALAN_KUNCI &&
    perhitunganPenjualan.sisa <= 0
  ) {
    return (
      <>
        <MasterButton
          onClick={(e) =>
            disabledTutupTransaksi.disabled
              ? null
              : handleClickTutupTransaksi(e)
          }
          className={"mt-1 w-full text-center"}
          type={"submit"}
          color={disabledTutupTransaksi.color}
          name={disabledTutupTransaksi.label}
          disabled={disabledTutupTransaksi.state}
          outline={true}
          size="lg"
        />

        {!isNull(formData.kunjungan_id) && (
          <MasterButton
            className={"mt-1 w-full text-center"}
            type={"button"}
            outline={true}
            onClick={(e) =>
              disabledTutupKunjungan.disabled
                ? null
                : handleClickTutupKunjungan(e)
            }
            color={disabledTutupKunjungan.color}
            name={disabledTutupKunjungan.label}
            disabled={disabledTutupKunjungan.state}
            size="lg"
          />
        )}
      </>
    )
  } else {
    return <></>
  }
}

export default ModalSimpan
